/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Lazy loading of a component MoneyTransfer
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.2.0
 */

import loadable from '../../utils/loadable';

export default loadable(() => import(/* webpackChunkName: "MoneyTransfer" */ './components/MoneyTransfer'), undefined);
